import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-735ab88c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "mechanical-arm-pose"
};
const _hoisted_2 = {
  class: "question-header"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "根据机械臂初始状态和指令，选择水瓶的最终姿态。", -1));
const _hoisted_4 = {
  class: "question-layout"
};
const _hoisted_5 = {
  class: "arm-figure"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "command-panel",
  "aria-label": "机械臂旋转指令"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "指令", -1));
const _hoisted_9 = {
  class: "command-order"
};
const _hoisted_10 = {
  class: "option-image-window"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "option-button-layer",
  role: "group",
  "aria-label": "请选择水瓶最终姿态"
};
const _hoisted_13 = ["disabled", "aria-label", "aria-pressed", "onClick"];
const _hoisted_14 = {
  key: 0,
  class: "asset-error",
  role: "alert"
};
const _hoisted_15 = {
  key: 1,
  class: "review-summary"
};
const _hoisted_16 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.data ? (_openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createElementVNode("h2", null, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1), _hoisted_3]), _createElementVNode("div", _hoisted_4, [_createElementVNode("figure", _hoisted_5, [_createElementVNode("img", {
    src: $props.data.initialImageUrl,
    alt: "机械臂与水瓶的初始状态，包含关节1到关节5",
    onError: _cache[0] || (_cache[0] = $event => $options.markFailed('initial'))
  }, null, 40, _hoisted_6)]), _createElementVNode("section", _hoisted_7, [_hoisted_8, _createElementVNode("ol", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.commands, command => {
    return _openBlock(), _createElementBlock("li", {
      key: command.order
    }, [_createElementVNode("span", _hoisted_9, _toDisplayString(command.order), 1), _createElementVNode("span", null, "关节" + _toDisplayString(command.jointId), 1), _createElementVNode("strong", null, _toDisplayString($options.directionText(command.direction)), 1), _createElementVNode("span", null, "旋转 " + _toDisplayString(command.angleDeg) + "°", 1)]);
  }), 128))])])]), _createElementVNode("div", {
    class: _normalizeClass(["option-stage", {
      unavailable: !$options.assetsReady,
      curated: $props.data.ruleVersion === 'mechanical-arm-curated-v1'
    }])
  }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
    src: $props.data.optionImageUrl,
    alt: "A到H八种水瓶姿态",
    onError: _cache[1] || (_cache[1] = $event => $options.markFailed('options'))
  }, null, 40, _hoisted_11)]), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.letters, letter => {
    return _openBlock(), _createElementBlock("button", {
      key: letter,
      type: "button",
      disabled: $props.reviewMode || !$options.assetsReady,
      "aria-label": `选择姿态 ${letter}`,
      "aria-pressed": $data.selectedAnswer === letter,
      class: _normalizeClass($options.buttonClass(letter)),
      onClick: $event => $options.selectAnswer(letter)
    }, [_createElementVNode("span", null, _toDisplayString(letter), 1)], 10, _hoisted_13);
  }), 128))])], 2), $data.assetError ? (_openBlock(), _createElementBlock("p", _hoisted_14, " 图片加载失败，请刷新页面后重试。 ")) : _createCommentVNode("", true), $props.reviewMode ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("span", null, [_createTextVNode("正确答案："), _createElementVNode("strong", null, _toDisplayString($props.data.rightAnswer), 1)]), _createElementVNode("span", null, [_createTextVNode("您的答案："), _createElementVNode("strong", null, _toDisplayString($props.review?.answer || '未作答'), 1)]), $props.data.statePath?.length ? (_openBlock(), _createElementBlock("span", _hoisted_16, "状态路径：" + _toDisplayString($props.data.statePath.join(' → ')), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
}